import { render, staticRenderFns } from "./totalResolutionTimeCrit.vue?vue&type=template&id=7d78e134"
import script from "./totalResolutionTimeCrit.vue?vue&type=script&lang=js"
export * from "./totalResolutionTimeCrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports